import React from 'react';

interface FlyingTheDroneCloudProps {
  size?: number; // Size of the entire component (circle + icon)
  iconColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const FlyingTheDroneCloud = ({ 
  size = 40, 
  iconColor = '#14142B',
  backgroundColor = '#F2F4F7',
  strokeWidth = 1.58333 
}: FlyingTheDroneCloudProps) => {
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M10.5234 17.5415C7.24425 17.5415 4.58594 14.8832 4.58594 11.604C4.58594 8.32481 7.24425 5.6665 10.5234 5.6665C12.8056 5.6665 14.787 6.95402 15.7809 8.8423C15.8749 8.83624 15.9696 8.83317 16.0651 8.83317C18.4698 8.83317 20.4193 10.7826 20.4193 13.1873C20.4193 15.5921 18.4698 17.5415 16.0651 17.5415C14.0452 17.5415 12.5995 17.5415 10.5234 17.5415Z" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

